export const DOMAIN_TITLE = 'MyQampus'
const examConstants = {
  MIN_EXAM_TIME_DURATION: 1,
}

export default examConstants
